class NewsletterPopup extends HTMLElement {
    constructor() {
        if (
            (super(),
            (this.popup = this),
            (this.timeToShow = parseInt(this.popup.getAttribute("data-delay"))),
            (this.expiresDate = this.popup.getAttribute("data-expire")),
            "" === this.getCookie("newsletter-popup"))
        ) {
            this.popup;
            setTimeout(function () {
                document.body.classList.add("newsletter-show");
            }, this.timeToShow),
                setTimeout(() => {
                    document.body.classList.add("show-newsletter-image");
                }, this.timeToShow + 700);
        }
        document.body.addEventListener("click", this.onBodyClickEvent.bind(this)),
            this.querySelector("[data-close-newsletter-popup]").addEventListener(
                "click",
                this.setClosePopup.bind(this)
            ),
            this.querySelector("#ContactPopup").addEventListener("submit", this.setClosePopup.bind(this));
    }
    setCookie(e, t, s) {
        const o = new Date();
        o.setTime(o.getTime() + 24 * s * 60 * 60 * 1e3);
        const i = "expires=" + o.toUTCString();
        document.cookie = e + "=" + t + ";" + i + ";path=/";
    }
    getCookie(e) {
        const t = e + "=",
            s = document.cookie.split(";");
        for (var o = 0; o < s.length; o++) {
            for (var i = s[o]; " " === i.charAt(0); ) i = i.substring(1);
            if (0 === i.indexOf(t)) return i.substring(t.length, i.length);
        }
        return "";
    }
    deleteCookie(e) {
        document.cookie = e + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
    setClosePopup() {
        this.setCookie("newsletter-popup", "closed", this.expiresDate),
            document.body.classList.remove("newsletter-show"),
            setTimeout(() => {
                document.body.classList.remove("show-newsletter-image");
            }, 700);
    }
    onBodyClickEvent(e) {
        !this.contains(e.target) &&
            0 === $(e.target).closest("[data-open-newsletter-popup]").length &&
            document.querySelector("body").classList.contains("newsletter-show") &&
            this.setClosePopup();
    }
}
customElements.define("newsletter-popup", NewsletterPopup);
class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super(),
            this.querySelector("[data-close-newsletter-message-popup]").addEventListener(
                "click",
                this.close.bind(this)
            ),
            document.body.addEventListener("click", this.onBodyClickEvent.bind(this));
    }
    close() {
        document.body.classList.remove("newsletter-message-show");
    }
    onBodyClickEvent(e) {
        this.contains(e.target) || this.close();
    }
}
customElements.define("newsletter-message-popup", NewsletterMessagePopup);
